<!-- Navbar (Header) Starts -->
<nav class="header-navbar navbar navbar-expand-sm">
  <div class="container-fluid">
    <div class="navbar-header">
      <button type="button" class="navbar-toggle d-lg-none float-left" data-toggle="collapse" (click)="toggleSidebar()">
        <span class="sr-only">Toggle navigation</span>
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
      </button>
      <span class="d-lg-none navbar-right navbar-collapse-toggle">
        <a class="open-navbar-container" (click)="isCollapsed = !isCollapsed" [attr.aria-expanded]="!isCollapsed" aria-controls="navbarSupportedContent">
          <i class="ft-more-vertical"></i>
        </a>
      </span>

    </div>
    <div class="navbar-container">
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav">
          <li class="nav-item mr-2">
            <a href="javascript:;" class="nav-link" appToggleFullscreen>
              <i class="ft-maximize font-medium-3 blue-grey darken-4"></i>
              <p class="d-none">fullscreen</p>
            </a>
          </li>
          <li class="nav-item mt-1" placement="bottom-right">
            <a class="logout-btn" (click)="logout()">
              <span class="mr-1">Cerrar sesión</span>
              <i class="fa fa-power-off"></i>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</nav>
<!-- Navbar (Header) Ends -->